import { render, staticRenderFns } from "./CollectionCardImageOverlay.vue?vue&type=template&id=66c40584&"
import script from "./CollectionCardImageOverlay.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardImageOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports